import React, { useEffect, useState } from "react";
import axios from "axios";
import { Table } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { BASE_URL } from "../../Constants";
import { CaretLeftOutlined } from "@ant-design/icons";

export default function TurnServers() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [turnServers, setServers] = useState([]);
  const columns = [
    {
      title: "",
      width: "5%",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: 150,
      filterable: true,
    },
    {
      title: "Server URL",
      dataIndex: "serverUrl",
      key: "serverUrl",
      width: 150,
      filterable: true,
    },
    {
      title: "Username",
      dataIndex: "userName",
      key: "url",
      width: 150,
      filterable: true,
    },

    {
      title: "Edit",
      dataIndex: "edit",
      key: "edit",
      render: (_, record) => (
        <Link
          to={`/turnServers/${record.id}`}
          className="text-orange-700 cursor-pointer hover:text-orange-800"
        >
          Edit
        </Link>
      ),
      width: 50,
    },
  ];

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${BASE_URL}/TurnServer`);
      const data = response.data;
      setServers(data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching turnServers:", error);
    }
  };

  return (
    <div className="mx-auto px-4 sm:px-6 text-white lg:px-8 mt-6 ">
      <div className="sm:flex sm:items-center">
        <div className="sm:flex-auto flex gap-2 items-center">
          <button
            type="button"
            className="block rounded-md bg-gray-700 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-gray-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#a85c4e]"
            onClick={() => navigate("/settings")}
          >
            <CaretLeftOutlined />
            Back
          </button>
          <h1 className="text-xl font-semibold leading-6 text-gray-200">
            Turn Servers
          </h1>
        </div>
        <div className="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
          <button
            type="button"
            className="block rounded-md bg-orange-700 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-orange-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#a85c4e]"
            onClick={() => navigate("/turnServers/new")}
          >
            New Turn Servers
          </button>
        </div>
      </div>
      <div className="border lg:my-3">
        <Table
          className=".custom-dark-table"
          loading={loading}
          dataSource={turnServers}
          columns={columns}
          rowKey="id" // Assuming the unique identifier for each turnServers is stored in the "id" property
        />
      </div>
    </div>
  );
}
